import { matchesSearchQuery } from '@/src/components/SearchBox/search.utils'

type SearchableEnpi = {
  title: string
  locationId?: number | null
  seuId?: { id?: string | null } | null
  seuMetadata?: { label?: string | null } | null
}

type SearchableSeries = {
  title?: string
}

export const matchesEnpiSearchQuery = (
  query: string,
  enpi: SearchableEnpi,
  locationNameById: ReadonlyMap<number, string>,
  seriesById: ReadonlyMap<string, SearchableSeries>
) => {
  let seriesTitle = enpi.seuMetadata?.label ?? undefined
  if (!seriesTitle && enpi.seuId?.id) {
    seriesTitle = seriesById.get(enpi.seuId.id)?.title
  }

  return matchesSearchQuery(query, [enpi.title, enpi.locationId ? locationNameById.get(enpi.locationId) : undefined, seriesTitle])
}
